import React, { useMemo } from 'react';
import RoleDashboardTemplate from './RoleDashboardTemplate';
import { useAuth } from '../../context/AuthContext';
import { buildRoleWorkspaceModules } from '../../config/roleWorkspaceConfig';

const EmployeeDashboardPage = () => {
  const auth = useAuth();
  const modules = useMemo(() => buildRoleWorkspaceModules('employee', auth), [auth]);

  return (
    <RoleDashboardTemplate
      title="User Dashboard"
      subtitle="Daily workspace for project work, entry posting, and profile management."
      modules={modules}
    />
  );
};

export default EmployeeDashboardPage;
